// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"B5x52zLX"};